import React from "react";
import { Link } from "react-router-dom";

export default function Faqs() {
  return (
    <div className="faqs">
      <div className="title">FAQs</div>
      <ul>
        <li className="p-3 has-text-weight-semibold has-background-light">
          How do I price my items?
        </li>
        <li className="mb-3 p-3">
          Begin by assessing the condition of your ski gear, taking note of any
          wear and tear. Research comparable items on consignment platforms to
          gauge market prices for similar gear in similar condition. Consider
          brand, quality, age, and the original retail price when setting your
          prices. Offer competitive prices, slightly below market value, to
          attract potential buyers. Price your items to SELL! No one wants to
          bring home unsold gear. Check out this pricing guide if you still have
          questions.
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          What do you charge for consignment?
        </li>
        <li className="mb-3 p-3">
          20% of the sale price is kept by the WES PTA to support our education
          programming. THANK YOU!
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          Where do I pick up my tags?
        </li>
        <li className="mb-3 p-3">
          <ul className="faq-points">
            <li>
              Tags will be available for pickup starting on the Wednesday before
              the sale (<strong>11/11</strong>) at Waitsfield Elementary School.
              They are in the 3 drawer cabinet by the front door. Please find the
              envelope with your last name. Your tags will be inside the
              envelope. If you are missing a tag please contact us at{" "}
              <a href="mailto:waitsfieldelementarypta@gmail.com">
                waitsfieldelementarypta@gmail.com
              </a>
              .
            </li>
            <li>
              Tags will be available in front of the school Wed-Fri, including
              at drop off Friday night if you were unable to pick them up
              before.
            </li>
          </ul>
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          How do I tag my items?
        </li>
        <li className="mb-3 p-3">
          <ul className="faq-points">
            <li>
              All tags are printed on adhesive labels.
              <br />
              <strong>Skis/Boards</strong> - Please attach the label directly to
              the ski.
              <br />
              <strong>Boots/Clothes/Hats/Mittens</strong> - Please fold the
              sticker OVER the tag with the string (Just the string should be
              coming out the top.). We made an example label for you and
              included the amount of labels needed for such items (clothing,
              accessories, boots). Please be sure to not fold the QR code on the
              label.
            </li>
            <li>
              It is recommended that if your item is a pair, please secure them
              together using string or rubber bands. Pairs such as base layers
              can be put in plastic zip lock bags.
            </li>
            <li>Be sure to securely attach the tags to your items!</li>
          </ul>
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          How do I know if my items sold?
        </li>
        <li className="mb-3 p-3">
          <Link to="/dashboard/inventory">Please check your inventory</Link>! All items
          sold will be listed in your inventory in real time. If all of your
          items sold you do not need to come to pick anything up!
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          Can I pick my items up early from the sale?
        </li>
        <li className="mb-3 p-3">
          Unfortunately, no. All consigned items can be picked up between 3:45
          and 4:15—NO EXCEPTIONS. If you cannot pick your items up during this
          timeframe, do not consign your items.
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          What happens if my items do not sell?
        </li>
        <li className="mb-3 p-3">
          <ul className="faq-points">
            <li>
              Check the <Link to="/dashboard/inventory">Current Inventory</Link>{" "}
              tab to see what has sold and what has not sold.
            </li>
            <li>
              If you would like your items back, pick up any unsold gear on
              Saturday from 3:45-4:15 during Consignment Pickup.
            </li>
            <li>
              If you do not want your unsold items back, they will be donated to
              the WES PTA and there is no need to retrieve them.
            </li>
            <li>
              Consignment Pickup 3:45-4:15. This is the ONLY opportunity to pick
              up unsold gear. Any unsold items not picked up by 4:15 will become
              property of the WES PTA.
            </li>
          </ul>
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          Oops! I forgot to pick my items! / I thought pick-up was Sunday! Is
          there any way to get my items back?
        </li>
        <li className="mb-3 p-3">
          Unfortunately, leftover items are unretrievable after the sale. If you
          cannot pickup your items find a friend to pick them up for you please
          or do not consign. All consigned items MUST be picked up between 3:45
          and 4:15—SATURDAY NO EXCEPTIONS.
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          When will I get my check?
        </li>
        <li className="mb-3 p-3">
          Checks will be mailed within a week after the sale to the address
          listed under "Profile".
        </li>
        <li className="p-3 has-text-weight-semibold has-background-light">
          Who do I contact if I have any questions?
        </li>
        <li className="mb-3 p-3">
          Please contact the Waitsfield Elementary School PTA at{" "}
          <a href="mailto:waitsfieldelementarypta@gmail.com">
            waitsfieldelementarypta@gmail.com
          </a>
        </li>
      </ul>
    </div>
  );
}
